import { PRODUCTS } from "./action";
const initialState = {
  isFetchingComplete: true,
  isError: false,
  productList: [],
  subscriptionData: {}
};

export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case PRODUCTS.subscribe.start:
      return {
        ...state,
        isFetchingComplete: false,
        isError: false,
        error: []
      };
    case PRODUCTS.list.start:
      return {
        ...state,
        isFetchingComplete: false,
        isError: false,
        productList: [],
        error: []
      };
    case PRODUCTS.subscribe.success:
      return {
        ...state,
        isFetchingComplete: true,
        isError: false,
        subscriptionData: action.data,
        error: []
      };
    case PRODUCTS.list.success:
      return {
        ...state,
        isFetchingComplete: true,
        isError: false,
        productList: action.data,
        error: []
      };
    case PRODUCTS.subscribe.error:
      return {
        ...state,
        isFetchingComplete: true,
        isError: true,
        error: action.data
      };
    case PRODUCTS.list.error:
      return {
        ...state,
        isFetchingComplete: true,
        isError: true,
        error: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/reducer.js